import { render } from "./UserAgreementScreen.vue?vue&type=template&id=331f59e2&scoped=true"
const script = {}

import "./UserAgreementScreen.vue?vue&type=style&index=0&id=331f59e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331f59e2"]])

export default __exports__